// log
import store from "../store";
import Web3 from "web3";

const fetchDataRequest = () => {
  return {
    type: "CHECK_DATA_REQUEST",
  };
};

const fetchDataSuccess = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS",
    payload: payload,
  };
};

const fetchDataFailed = (payload) => {
  return {
    type: "CHECK_DATA_FAILED",
    payload: payload,
  };
};

export const fetchData = () => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      let currentAddress = await store.getState().blockchain.account;

      let potatoBalance = await store.getState().blockchain.smartContract.methods.getPotatoBalance(currentAddress).call();
      let costonBalance = await store.getState().blockchain.smartContract.methods.getCostonBalance(currentAddress).call();
    
      let totalSupply = [potatoBalance, costonBalance];
      
      dispatch(
        fetchDataSuccess({
          totalSupply,
        })
      );
    } catch (err) {
      console.log(err);
      dispatch(fetchDataFailed("Could not load data from contract."));
    }
  };
};